import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import { injectIntl } from 'react-intl';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import messages from 'aurora-translations';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import PropertySummary from './Summary';
import styles from './styles';
function PropertyList(props) {
  const { classes, data, locale, history, intl, selected, setSelected, selectable, multi, ...otherProps } = props;

  const [selectAll, setSelectAll] = useState(null);

  const selectAllHandler = e => {
    if (e.target.checked) {
      setSelectAll(true);
      const newProjects = data?.projects?.filter(
        proj => (selected || [])?.find(project => project?.id === proj?.id) === undefined,
      );
      if (selected) {
        setSelected([...selected, ...newProjects]);
      } else {
        setSelected([...newProjects]);
      }
    } else {
      setSelectAll(false);
      setSelected(
        selected?.filter(
          selectedProject => data?.projects?.find(project => project?.id === selectedProject?.id) === undefined,
        ),
      );
    }
  };

  return (
    <>
      {!isEmpty(data) && selectable && multi && (
        <div className={classes.selectAllContainer}>
          <FormControlLabel
            className={classes.inputCheckbox}
            onChange={selectAllHandler}
            label={intl.formatMessage({ ...messages.select_all })}
            control={
              <Checkbox
                edge='start'
                checked={selectAll}
                indeterminate={isArray(selected) && selected?.length > 1}
                classes={{
                  root: classes.itemCheckbox,
                  checked: classes.itemCheckboxChecked,
                  indeterminate: classes.itemCheckboxIndeterminate,
                }}
              />
            }
          />
        </div>
      )}

      <List className={classes.propertiesList}>
        {data?.projects?.map((item, index) => (
          <PropertySummary
            key={`summary-${index + 1}`}
            locale={locale}
            project={item}
            selected={selected}
            setSelected={setSelected}
            selectable={selectable}
            multi={multi}
            {...otherProps}
          />
        ))}
      </List>
    </>
  );
}

PropertyList.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  history: PropTypes.object,
  intl: PropTypes.object.isRequired,
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  selectable: PropTypes.bool.isRequired,
  multi: PropTypes.bool.isRequired,
};
PropertyList.defaultProps = {
  isPMA: false,
  history: {},
};

export default withStyles(styles)(injectIntl(memo(PropertyList)));
